import React, { type FC, useMemo } from 'react'
import { FormControlLabel } from '@mui/material'

import { objectEntries } from '../../../utils'

import { selectUserManagementSelectedTabShowInternal, Translation, type UserManagementTabsTypes } from '../../../domain'

import { Switch } from '../common'
import { FormattedTranslation } from '../Internationalization'
import { useRouting } from '../routing'
import { useAppState, useAppUsecase } from '../State'
import { tabs } from './Config'

const useSelectedTab = (): keyof UserManagementTabsTypes | null => {
    const routing = useRouting()

    return useMemo(() => {
        let selected: ReturnType<typeof useSelectedTab> = null

        for (const [tab, route] of objectEntries(tabs)) {
            if (routing.isAtRoute(route)) {
                selected = tab
                break
            }
        }

        return selected
    }, [routing])
}

export const Filter: FC = () => {
    const usecase = useAppUsecase('filterUserManagementUsecase')

    const selected = useSelectedTab()
    const isShow = useAppState((s) => selected && selectUserManagementSelectedTabShowInternal(s, selected), [selected])

    return (
        selected !== null &&
        isShow !== null && (
            <FormControlLabel
                control={<Switch data-testid="show-internal" checked={isShow} onChange={() => usecase.toggleShowInternal(selected)} />}
                label={<FormattedTranslation id={Translation.SHOW_USER_MANAGEMENT_RESULTS} values={{ type: selected }} />}
            />
        )
    )
}
